// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-design-strategy-js": () => import("../src/pages/design-strategy.js" /* webpackChunkName: "component---src-pages-design-strategy-js" */),
  "component---src-pages-implementation-js": () => import("../src/pages/implementation.js" /* webpackChunkName: "component---src-pages-implementation-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-join-js": () => import("../src/pages/join.js" /* webpackChunkName: "component---src-pages-join-js" */)
}

